import { useEffect } from 'react';

import { useUnit } from 'effector-react';

import { hasStpOnboardingTasks } from '../onboardingExperimentCohort';

import { onboardingSessionStore, setIsStpFlow } from './onboardingSession';

type StpOnboardingFlowContext = {
  hasFetchedTodo: boolean;
  isOnTaskOnboardingPath: boolean;
  onboardingTasks:
    | {
        confirmVisit?: unknown;
        selectVisitDuration?: unknown;
      }
    | null
    | undefined;
};

export function useStpOnboardingFlow({
  hasFetchedTodo,
  isOnTaskOnboardingPath,
  onboardingTasks,
}: StpOnboardingFlowContext): boolean {
  const hasCurrentStpOnboardingTasks = hasStpOnboardingTasks(onboardingTasks);
  const { isStpFlow } = useUnit(onboardingSessionStore);

  useEffect(() => {
    if (hasCurrentStpOnboardingTasks) {
      setIsStpFlow(true);
    } else if (hasFetchedTodo && !isOnTaskOnboardingPath) {
      setIsStpFlow(false);
    }
  }, [hasCurrentStpOnboardingTasks, hasFetchedTodo, isOnTaskOnboardingPath]);

  return hasCurrentStpOnboardingTasks || isStpFlow;
}
